module.exports = __webpack_public_path__ + "static/img/quxiaojingyin2.c5477e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/quxiaojingyin2.png
// module id = 0IQq
// module chunks = 24